import { useEffect, useState } from 'react';
import { get, post } from '../../Services/api'
import { useAuth } from '../../Components/AuthContext/AuthContext'
import './analytics.css'

import IntakeOverview from '../Dashboard/IntakeOverview/IntakeOverview';
import DashboardMoney from '../Dashboard/Money/Money';
import DashboardWaterHistory from './WaterHistory/WaterHistory';
import AnalyticsBMI from './BMI/bmi';
import AnalyticsWeight from './Weight/weight';

function Analytics() {
    const { currentUser, userInfo } = useAuth();

    return (
        <div className='dashboard_one_column_grid'>
            <div className='dashboard_three_column_grid'>
                <div className='grid_2_span dashboard_indiv_components'>
                    <IntakeOverview currentUser={currentUser} />
                </div>

                <div className='grid_1_span dashboard_indiv_components'>
                    <DashboardMoney currentUser={currentUser} userConfig={userInfo} />
                </div>
            </div>

            <div className='dashboard_three_column_grid'>
                <div className='dashboard_indiv_components'>
                    <DashboardWaterHistory currentUser={currentUser} />
                </div>

                <div className='dashboard_indiv_components'>
                    <AnalyticsBMI currentUser={currentUser} />
                </div>

                <div className='dashboard_indiv_components'>
                    <AnalyticsWeight currentUser={currentUser} />
                </div>
            </div>
            <br />
        </div>
    );
}


export default Analytics;